export const MUTATION_TYPES = {
	SET_CAMPAIGN_IDENTIFIER: 'setCampaignIdentifier',
	SET_CAMPAIGN: 'setCampaign',
	SET_CATEGORIES: 'setCategories',
	SET_BRANDS: 'setBrands',
	SET_MODELS: 'setModels',
	SET_COLORS: 'setColors',
	RESET_CATEGORIES: 'resetCategories',
	RESET_BRANDS: 'resetBrands',
	RESET_MODELS: 'resetModels',
	RESET_COLORS: 'resetColors',
	RESET_DEVICE_FINDER: 'resetDeviceFinder',
	SET_SELECTED_CATEGORY: 'setSelectedCategory',
	SET_SELECTED_BRAND: 'setSelectedBrand',
	SET_SELECTED_MODEL: 'setSelectedModel',
	SET_SELECTED_COLOR: 'setSelectedColor',
	SET_SELECTED_CATEGORY_BY_SEO_NAME: 'setSelectedCategoryBySeoName',
	SET_SELECTED_BRAND_BY_SEO_BANE: 'setSelectedBrandBySeoName',
	SET_SELECTED_MODEL_BY_SEO_NAME: 'setSelectedModelBySeoName',
	SET_SELECTED_COLOR_BY_SEO_NAME: 'setSelectedColorBySeoName',
	SET_LOADING_CATEGORIES: 'setLoadingCategories',
	SET_LOADING_BRANDS: 'setLoadingBrands',
	SET_LOADING_MODELS: 'setLoadingModels',
	SET_LOADING_COLORS: 'setLoadingColors',
	SET_GENDERS: 'setGenders',
	SET_STATES: 'setStates',
	SET_CONTRACT_FORM: 'setContractForm',
	SET_QUALITIES: 'setQualities',
	SET_QUALITY_TYPES: 'setQualityTypes',
	SET_SELECTED_QUALITY: 'setSelectedQuality',
	SET_APPRAISAL: 'setAppraisal',
	SET_USER_BUYOUT_CODE: 'setUserBuyoutCode',
	SET_CANNOT_BE_BUYOUT: 'setCannotBeBuyout',
	SET_DISPLAY_THANK_YOU: 'setDisplayThankYou',
	SET_IS_APPRAISAL_EDITABLE: 'setIsAppraisalEditable',
	SET_APPRAISAL_ERRORS: 'setAppraisalErrors',
	SET_APPRAISAL_RESULTS: 'setAppraisalResults',
	SET_APPRAISAL_LOAD_ERROR: 'setAppraisalLoadError',
	SET_DEFAULT_QUALITY_CONDITIONS: 'setDefaultQualityConditions',
	SET_BUYOUT_BONUSES: 'setBuyoutBonuses',
	SET_IS_PRE_SALE_INFO: 'setIsPreSaleInfo',
	SET_IS_BUYOUT_ONLINE: 'setIsBuyoutOnline',
	SET_PRE_SALE_INFO_EMAIL: 'setPreSaleInfoEmail',
	SET_BUYOUT_LOAD_ERROR: 'setBuyoutLoadError',
	SET_BUYOUT_STATE: 'setBuyoutState',
	SET_IS_REGISTRATION: 'setIsRegistration',
	SET_IS_LOGGED_IN: 'setIsLoggedIn',
	SET_SELECTED_BONUS: 'setSelectedBonus',
	SET_BUYOUT_RECEIPT: 'setBuyoutReceipt',
	SET_BUYOUT_RECEIPT_ERRORS: 'setBuyoutReceiptErrors',
	SET_PICKUP_ADDRESS: 'setPickupAddress',
	SET_PICKUP_ADDRESS_ERRORS: 'setPickUpAddressErrors',
	SET_NEW_DEVICE_IMEI: 'setNewDeviceImei',
	SET_NEW_DEVICE_IMEI_ERRORS: 'setNewDeviceImeiErrors',
	SET_NEW_DEVICE_IMEI_SAVED: 'setNewDeviceImeiSaved',
	SET_EDITABLE_IMEI: 'setEditableImei',
	SET_DISABLE_BUYOUT_SEND_BTN: 'setDisableBuyoutSendBtn',
	SET_STATE_TYPES: 'setStateTypes',
	SET_BUYOUT_STATE_IDENTIFIER: 'setBuyoutStateIdentifier',
	SET_COMMON_ERROR: 'setCommonError',
	SET_PARTNERS: 'setPartners',
	SET_SELECTED_PARTNER: 'setSelectedPartner',
	SET_CONSENT_TO_MARKETING: 'setConsentToMarketing',
	SET_FORM_FIELD: 'setFormField',
	SET_LOADING_APPRAISAL: 'setLoadingAppraisal',
	SET_BUYOUT_ADDITIONAL_INFO: 'setBuyoutAdditionalInfo',
	SET_BUYOUT_ADDITIONAL_INFO_ERRORS: 'setBuyoutAdditionalInfoErrors',
	SET_BUYOUT_LOADING: 'setBuyoutLoading',
	SET_DIFFERENT_PICKUP_ADDRESS: 'setDifferentPickupAddress',
	SET_IS_DIFFERENT_PICKUP_ADDRESS: 'setIsDifferentPickupAddress',
	SET_NEW_DEVICE_ORDER_NUMBER: 'setNewDeviceOrderNumber',
	SET_SELECTED_NEW_MODEL: 'setSelectedNewModel',
	SET_SELECTED_NEW_MODEL_PARTNER: 'setSelectedNewModelPartner',
	SET_BUYOUT_ADDITIONAL_INFO_BY_KEY: 'setBuyoutAdditionalInfoByKey',
}
